module.controller(
    'planSamplingDetailCtrl',
    [ '$scope', '$rootScope', '$state', 'planSamplingService', 'alertService', 'ASEBIOL_CONSTANTS',
        function($scope, $rootScope, $state, planSamplingService, alertService, ASEBIOL_CONSTANTS) {
            $scope.operationType = $state.current.data.type;
            
            $scope.idPlanSampling = $state.params.id;
            $scope.planSampling = {
            	client: {}
            };
            $scope.loading = false;
            $scope.clientCustomFilter = {
            		active: true
            };
            
            $scope.DATE_FORMAT = ASEBIOL_CONSTANTS.DATE_FORMAT;

            $scope.options = {
            	    minDate: new Date(),
            	  };
            
            $scope.load = function(idPlan) {
                $scope.loading = true;

                planSamplingService.getPlanSampling(idPlan).then(function(response) {
                    $scope.loading = false;

                    var responseData = response.getData();
                    
                    $scope.planSampling = {
                    	name : responseData.name,
                    	state : responseData.state,
                    	startDate: moment(responseData.startDate, ASEBIOL_CONSTANTS.DATE_FORMAT_MOMENT).toDate(),
                    	client: {
                    		selected:[{
                    			id: responseData.client.id,
                    			name : responseData.client.name,
                                businessName : responseData.client.businessName,
                                identificationNumber: responseData.client.identificationNumber,
                                identificationType: {
                              		  id: responseData.client.identificationType.id,
                              		  name: responseData.client.identificationType.name,
                              		  value: responseData.client.identificationType.value
                              		 }
                    		}]
                    	}
                    }
                    
                    if ($scope.operationType == 'clone'){
                    	$scope.planSampling.name = 'Copia de '+$scope.planSampling.name;
                    	$scope.planSampling.startDate = Date.now();
                    }
                }, function(response) {
                    $scope.loading = false;
                });
            };

            /**
             *
             */
            $scope.sendAction = function() {
                if ($scope.operationType == 'create') {
                    $scope.create();
                }else if ($scope.operationType == 'clone') {
                    $scope.clone();
                } else {
                    $scope.update();
                }
            };

            /**
             *
             */
            $scope.create = function() {
                alertService.showSwtQuestion('Crear Plan de muestreo', function() {
                    $scope.loading = true;

                    var createModel = {
                    	name: $scope.planSampling.name,
                    	idClient: $scope.planSampling.client.selected[0].id
                    };
                    
                    if($scope.planSampling.startDate){
                    	createModel.startDate = moment($scope.planSampling.startDate).format(ASEBIOL_CONSTANTS.DATE_FORMAT_MOMENT);
                    }

                    planSamplingService.createPlanSampling(createModel).then(function(response) {
                        $scope.loading = false;
                        alertService.showSuccess('Plan creado satisfactoriamente');
                        $state.go('home.planSamplingList');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };

            /**
             *
             */
            $scope.update = function() {
                alertService.showSwtQuestion('Actualizar plan de muestreo', function() {
                    $scope.loading = true;

                    var updateModel = {
                    		name: $scope.planSampling.name.replace(/\s+/g,' ')
                        };
                    if($scope.planSampling.startDate && $scope.planSampling.state === 'EDITION'){
                    	updateModel.startDate = moment($scope.planSampling.startDate).format(ASEBIOL_CONSTANTS.DATE_FORMAT_MOMENT);
                    }
                    
                    planSamplingService.updatePlanSampling($scope.idPlanSampling, updateModel).then(function(response) {
                        $scope.loading = false;
                        alertService.showSuccess('plan de muestreo actualizado satisfactoriamente');
                        $state.go('home.planSamplingHome',{id:$scope.idPlanSampling});
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };
            
            $scope.clone = function() {
                alertService.showSwtQuestion('Clonar plan de muestreo', function() {
                    $scope.loading = true;

                    var cloneModel = {
                    		name: $scope.planSampling.name,
                        	idClient: $scope.planSampling.client.selected[0].id
                        };
                    if($scope.planSampling.startDate){
                    	cloneModel.startDate = moment($scope.planSampling.startDate).format(ASEBIOL_CONSTANTS.DATE_FORMAT_MOMENT);
                    }
                    
                    planSamplingService.clonePlanSampling($scope.idPlanSampling, cloneModel).then(function(response) {
                        $scope.loading = false;
                        var idClonePlan = response.getData().id;
                        alertService.showSuccess('plan de muestreo clonado satisfactoriamente');
                        $state.go('home.planSamplingHome',{id:idClonePlan});
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };
            
            $scope.goback = function(){
            	if ($scope.operationType == 'create'){
            		$state.go('home.planSamplingList');
            	}else{
            		$state.go('home.planSamplingHome',{id:$scope.idPlanSampling});
            	}            	
            }

            if ($scope.operationType == 'update' || $scope.operationType == 'clone') {
                $scope.load($state.params.id);
            }

        } ]);


